import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "line-chart" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<h1>Pie Chart</h1><p> To create a pie chart in <b>vue3-charts</b> you can use the <code>Pie</code> layer. You <b class=\"text-red-500\">cannot</b> add the <code>Pie</code> layer multiple times or combine it with other layers (<code>Bar</code>, <code>Area</code>). </p><p>Here you can see a simple example using <code>Pie</code> layer.</p>", 3)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { class: "mt-6" }, "Pie layer props", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "The pie layer allows a number of properties to be specified.", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "mb-2" }, "Use pieStyle to set svg styling for the pie.", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold" }, "Ex:", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("ul", { class: "list-disc list-inside" }, [
  /*#__PURE__*/_createElementVNode("li", null, "colors (ex. ['#4daf4a', '#377eb8'])"),
  /*#__PURE__*/_createElementVNode("li", null, "innerRadius"),
  /*#__PURE__*/_createElementVNode("li", null, "cornerRadius"),
  /*#__PURE__*/_createElementVNode("li", null, "padAngle")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", null, "What data the line to render.", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode("Ex: "),
  /*#__PURE__*/_createElementVNode("code", null, "['name', 'pl']")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PieChart = _resolveComponent("PieChart")!
  const _component_ChartBlock = _resolveComponent("ChartBlock")!
  const _component_Prop = _resolveComponent("Prop")!
  const _component_PropsBlock = _resolveComponent("PropsBlock")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_ChartBlock, {
      chartCode: _ctx.code.chartCode,
      dataCode: _ctx.code.dataCode
    }, {
      default: _withCtx(() => [
        _createVNode(_component_PieChart)
      ]),
      _: 1
    }, 8, ["chartCode", "dataCode"]),
    _hoisted_5,
    _hoisted_6,
    _createVNode(_component_PropsBlock, { class: "mt-4" }, {
      default: _withCtx(() => [
        _createVNode(_component_Prop, {
          name: "pieStyle",
          types: ['Object']
        }, {
          default: _withCtx(() => [
            _hoisted_7,
            _hoisted_8,
            _hoisted_9
          ]),
          _: 1
        }),
        _createVNode(_component_Prop, {
          name: "dataKeys",
          types: ['Array']
        }, {
          default: _withCtx(() => [
            _hoisted_10,
            _hoisted_11
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}